exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-container[data-v-4ab1f1d7]{white-space:nowrap;position:relative;overflow:hidden;width:100%}.scroll-container[data-v-4ab1f1d7] .el-scrollbar__bar{bottom:0}.scroll-container[data-v-4ab1f1d7] .el-scrollbar__wrap{height:49px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ab1f1d7","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ScrollPane/index.vue
// module id = wTgS
// module chunks = 55